import { FileConfig } from "./uploadFileConfig";

// Pages that live outside the sidebar (the Files page) open the report upload
// modal pre-filled with existing files through this event; Menu owns the modal
// and listens for it. Same mechanism as the pnai:add-to-report-* window events.
export const OPEN_REPORT_UPLOAD_EVENT = "pnai:open-report-upload";

export function openReportUpload(files: FileConfig[]) {
  window.dispatchEvent(
    new CustomEvent<FileConfig[]>(OPEN_REPORT_UPLOAD_EVENT, { detail: files }),
  );
}
